import React, {ReactNode, useMemo} from "react";
import {Icon, IconType, TabControl, TabControlButton, TabControlPage} from "peggirkit";
import SlimContainer from "../layout/SlimContainer";
import GeneralSettingsTab from "./settings/general/GeneralSettingsTab";
import SecuritySettingsTab from "./settings/security/SecuritySettingsTab";
import {LockClosedIcon, UserIcon} from "@heroicons/react/24/outline";
import {useIntl} from "react-intl";

type AccountSettingsTabs = {
    name: string,
    icon: IconType,
    contents: ReactNode,
};

const AccountSettings = () => {
    const intl = useIntl();
    const tabs: AccountSettingsTabs[] = useMemo(() => ([
        {
            name: intl.formatMessage({id: "general"}),
            icon: UserIcon,
            contents: <GeneralSettingsTab/>,

        },
        {
            name: intl.formatMessage({id: "security"}),
            icon: LockClosedIcon,
            contents: <SecuritySettingsTab/>,
        },
    ]), [intl]);

    return (
        <TabControl
            tabsListStyle={{type: "select-list"}}
            urlParameterConfig={{name: "section"}}
            containerClassname={"py-3 md:py-6"}
            panelWrapper={children => <SlimContainer>{children}</SlimContainer>}
            breakpoints={{
                md: {
                    tabsListStyle: {
                        type: "button-row"
                    }
                },
            }}
        >
            {tabs.map((tab: AccountSettingsTabs, i: number) =>
                <TabControlPage
                    key={i}
                    tabButton={
                        <TabControlButton iconBefore={<Icon icon={tab.icon}/>}>
                            {tab.name}
                        </TabControlButton>
                    }
                >
                    {tab.contents}
                </TabControlPage>
            )}
        </TabControl>
    );
};

export default AccountSettings;